const NBSP_CHAR_CODE = 160;

export const cropText = (text: string, limit: number) => {
  let textOutput = text;

  if (textOutput.length >= limit) {
    textOutput = textOutput.trim().replace(/[^a-zа-я0-9]+$/i, '');
    if (textOutput.length >= limit) {
      textOutput = textOutput.substr(0, limit - 1);
      textOutput = textOutput.replace(/[^a-zа-я0-9]+$/i, '');
    }
    textOutput += '\u2026';
  }

  return textOutput;
};

export function replaceNBSP(srt: string): string {
  const nbspRegExp = new RegExp(String.fromCharCode(NBSP_CHAR_CODE), 'g');

  return srt.replace(nbspRegExp, ' ');
}
